// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"e817b2b1","761":"d3829877"}[chunkId] + ".chunk.css";
};